<template>
   <div id='provideHot' class='provide_container'></div>
</template>

<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/line'
import { option as lineOption } from '@/zjljChartsConfig/provideHotOption.js' // 供应热度
// import {option as dataResponse} from '@/zjljChartsConfig/provideData.js' //供应热度配置
import { filterArr } from '@/utils/dataFilter.js' // 数组空值转换

export default{
  props: {
    // productId: {
    //   type: Number,
    //   default: 0
    // },
    countyId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      xAxisData: [],
      currentYearDataStore: [],
      lastYearDataStore: [],
      showCount: 12, // 显示的数据数量
      showIndexPre: 0,
      showIndexLast: 20
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      switch (this.$route.name) {
        case 'gdLitchi': {
          this.productId = this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'sxhlg': {
          this.productId = this.productId || this.$route.params.product_id || 7832
          break
        }
        case 'mmlz': {
          this.productId = this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'zjlj': {
          this.productId = this.productId || this.$route.params.product_id || 8016
          break
        }
        case 'mzyz': {
          this.productId = this.productId || this.$route.params.product_id || 8519
          break
        }
        default: {
          this.productId = this.productId || this.$route.params.product_id
        }
      }
      http.get('/canmou/tianji/product/supply_index?product_id=' + this.productId + '&county_id=' + this.countyId).then(res => {
        this.dataResponse = res.data
        this.currentYearDataStore = filterArr(this.dataResponse.data.current_year_supply)
        this.lastYearDataStore = filterArr(this.dataResponse.data.last_year_supply)
        if (this.dataResponse.data.two_year_ago_supply) {
          this.twoYearDataStore = filterArr(this.dataResponse.data.two_year_ago_supply)
        }
        this.countAll = this.dataResponse.data.last_year_supply.length
        this.xAxisDataStore = this.dataResponse.data.date.map(item => {
          return `${item.substr(0, 2)} / ${item.substr(2)}`
        })
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 初始化数据
    setData () {
      let len = this.xAxisDataStore.length
      this.currentYearData = this.currentYearDataStore.slice(0, len)
      this.lastYearData = this.lastYearDataStore.slice(0, len)
      if (this.twoYearDataStore) {
        this.twoYearData = this.twoYearDataStore.slice(0, len)
      }
      this.xAxisData = this.xAxisDataStore.slice(0, len)
      // 设置配置数据interval属性
      const interval = Math.floor(this.xAxisData.length / this.showCount) - 1
      lineOption.xAxis[0].axisLabel.interval = interval < 2 ? 2 : interval
      // x轴数据
      lineOption.xAxis[0].data = this.xAxisData
      // 线数据
      if (this.$route.name === 'hzLitchi') {
        lineOption.legend.textStyle.fontSize = 21
        lineOption.xAxis[0].axisLabel.textStyle.fontSize = 24
        lineOption.xAxis[0].axisLabel.textStyle.fontWeight = 'bold'
        lineOption.yAxis[0].axisLabel.textStyle.fontSize = 24
        lineOption.yAxis[0].axisLabel.textStyle.fontWeight = 'bold'
      }
      if (this.$route.name === 'xvData') {
        lineOption.legend.textStyle.fontSize = 21
        lineOption.xAxis[0].axisLabel.textStyle.fontSize = 22
        lineOption.yAxis[0].axisLabel.textStyle.fontSize = 22
        lineOption.legend.data = ['2019', '2020', '2021']
        lineOption.series = [
          {
            name: '2019',
            type: 'line',
            data: this.twoYearData,
            smooth: true,
            lineStyle: {
              normal: {
                width: 5
              //  color: '#F58080'
              }
            }
          },
          {
            name: '2020',
            type: 'line',
            data: this.lastYearData,
            smooth: true,
            lineStyle: {
              normal: {
                width: 5
              //  color: 'yellow'
              }
            }
          }, {
            name: '2021',
            type: 'line',
            data: this.currentYearData,
            smooth: true,
            lineStyle: {
              normal: {
                width: 5
              //  color: 'yellow'
              }
            }
          }]
      } else {
        lineOption.series = [
          {
            name: '今年',
            type: 'line',
            data: this.currentYearData,
            smooth: true,
            lineStyle: {
              normal: {
                width: 5
              //  color: '#F58080'
              }
            }
          },
          {
            name: '去年',
            type: 'line',
            data: this.lastYearData,
            smooth: true,
            lineStyle: {
              normal: {
                width: 5
              //  color: 'yellow'
              }
            }
          }]
      }
      this.lineChart.setOption(lineOption)
    },
    initOption () {
      if (!this.lineChart) {
        this.lineChart = echarts.init(document.getElementById('provideHot'))
      } else {
        this.lineChart.clear()
      }
      // 改变数据设置动效
      var that = this
      let changeLinePoint = () => {
        if (that.showIndexLast >= that.countAll) {
          that.showIndexPre = -1
          that.showIndexLast = that.showCount - 1
        }
        // that.showIndexPre++;
        // that.showIndexLast++;
        that.showIndexPre = 0
        that.showIndexLast = that.xAxisDataStore.length
        that.currentYearData.length = 0
        that.currentYearData.push(...that.currentYearDataStore.slice(that.showIndexPre, that.showIndexLast))
        that.lastYearData.length = 0
        that.lastYearData.push(...that.lastYearDataStore.slice(that.showIndexPre, that.showIndexLast))
        that.xAxisData.length = 0
        that.xAxisData.push(...that.xAxisDataStore.slice(that.showIndexPre, that.showIndexLast))
        that.lineChart.setOption(lineOption)
      }
      init()
      function init () {
        // 获取数据
        that.getData(() => {
          // 处理返回数据
          that.setData(that.dataResponse)
          // 设置数据切换
          changeLinePoint()
        })
      }
      // clearInterval(this.timer)
      // // 更新数据 展示注释
      // this.timer = setInterval(function () {
      //   init()
      // }, 2000)
    }
  },
  watch: {
    // productId (val) {
    //   this.initOption()
    // }
    $route (to, from) {
      console.log('child watch $route', to, from)
      if (to.params && to.params.product_id !== from.params.product_id) {
        this.productId = to.params.product_id
        this.initOption()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {
    this.initOption()
  }
}

</script>
<style lang='less' scoped>

  .provide_container{
    width: 100%;
    height:100%;
    background:none;
  }
</style>
